import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Bau365DataAccessUserModule } from '@planone/bau365/data-access-user';

import { ToggleWatchlistItemComponent } from './toggle-watchlist-item/toggle-watchlist-item.component';

@NgModule({
  imports: [CommonModule, Bau365DataAccessUserModule, MatButtonModule, MatIconModule],
  declarations: [ToggleWatchlistItemComponent],
  exports: [ToggleWatchlistItemComponent],
})
export class Bau365FeatureWatchlistSharedModule {}
